import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import FormElementLogin from './form_element_login.js';
import FormElementRegister from './form_element_register.js';

export default class LoginForm extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			loading: false,
			form: "login",
			error: false,
			notverified: false,
			notice: ""
		};
		
		this.callbackRequest = this.callbackRequest.bind(this);
		this.changeForm = this.changeForm.bind(this);
		this.errorState = this.errorState.bind(this);
		this.loadingState = this.loadingState.bind(this);
	}
	
	callbackRequest(response) {
		
		var { error, notice, notverified } = this.state;
		
		if (!response || !response.success)
		{
			error = true;
		}
		
		if (response && response.report && response.report.break != "")
		{
			notice = response.report.break;
		}
		
		if (response && response.report && response.report.code && response.report.code == 122)
		{
			notice = "";
			
			error = false;
			
			notverified = response.report.break;
		}
		
		if (response.success && document.getElementById("loading-screen"))
		{
			location.reload();
		}
		
		this.setState({ loading: false, error, notice, notverified });
	}
	
	changeForm(e) {
		
		var { form } = this.state;
		
		// Save value
		if (e.target.getAttribute("action") == "register")
		{
			form = "register";
		}
		else
		{
			form = "login";
		}
		
		this.setState({ form });
	}
	
	errorState(error) {
		
		this.setState({ error });
	}
	
	loadingState(loading) {
		
		this.setState({ loading });
	}
	
	render() {
		
		const { loading, error, notice, form, notverified } = this.state;
		
		const { callbackRequest, changeForm, errorState, loadingState } = this;
		
		const linkLogo = /*"http://root.localhost/assembler/export/public_html" + */"/file/mail_logo.png";
		
		const props = {
			error: error,
			loading: loading,
			linkLogo: linkLogo,
			notice: notice,
			changeForm: changeForm,
			errorState: errorState,
			loadingState: loadingState,
			callbackRequest: callbackRequest
		};
		
		return (
			<div className="login-form">
				<style>{`
					#login-form,
					#login-form > div,
					#login-form > div > div.login-form {
						height: 100%;
					}
					#login-form {
						background: linear-gradient(to right, #849095, #5b5e68);
					}
				`}</style>
				<Grid textAlign="center" style={{ height: "100%" }} verticalAlign="middle">
					{
						form == "login" ?
							<FormElementLogin notverified={notverified} {...props} />
						:
							<FormElementRegister {...props} />
					}
				</Grid>
			</div>
		);
	}
}